// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"178":"0099caa3","195":"e20ba1ac"}[chunkId] + ".js";
};